module.exports = __webpack_public_path__ + "static/media/manha.3d75913d.svg";